export const properties = variables => ({
  operationName: 'CMS_PropertiesView',
  variables,
  query: `
    query CMS_PropertiesView(
      $pageNumber: Int!,
      $pageSize: Int!,
      $sortBy: PropertySortBy,
      $sortDirection: SortDirection,
      $countrySlug: String,
      $citySlug: String,
      $landlordSlug: String,
      $statuses: [PropertyStatus!],
      $fullName: String,
      $propertyType: String,
      $isCheckAuth:Boolean,
      $bookingJourneys:[BookingJourney!]
    ) {
    properties(
      pageNumber: $pageNumber,
      pageSize: $pageSize,
      sortBy: $sortBy,
      sortDirection: $sortDirection,
      countrySlug: $countrySlug,
      citySlug: $citySlug,
      landlordSlug: $landlordSlug,
      statuses: $statuses
      fullName: $fullName,
      propertyType: $propertyType,
      isCheckAuth:$isCheckAuth,
      bookingJourneys:$bookingJourneys
    ) {
      pageInfo {
        numPages
      }
      totalCount
      edges {
        node {
          propertyType {
            description
            id
            name
            slug
          }
          name
          slug
          id
          state
          bookingJourney
          contractStage
          publishCondition {
            commissionTier
            contractStage
            paymentPlan
            payout
            offlinePaymentMethod
          }
          paymentPlan {
            paymentOnline
          }
          contracts {
            id
          }
          commissionTiers {
            id
            status
          }
          reviewsSummary {
            count
            averageRating
          }
          city {
            name
            slug
            published
            country {
              name
              slug
            }
          }
          landlord {
            businessScale
            name
            slug
            contractStage
          }
          images {
            edges {
              node {
                path
                source
                hero
              }
            }
          }
          status
          updatedAt
          updatedBy
          updatedByUser {
            name
          }
          drafts {
            edges {
              node {
                id
                status
              }
            }
          }
        }
      }
    }
  }`,
});

export const specialOfferList = variables => ({
  operationName: 'listSpecialOffer',
  variables,
  query: `
    query listSpecialOffer(
      $pageNumber: Int!,
      $pageSize: Int!,
      $sortBy: SpecialOfferSortBy,
      $sortDirection: SortDirection,
      $statuses: [SpecialOfferStatus!],
      $internalTitle: String,
      $propertyId: ID,
      $cityId: Int,
      $landlordId: Int,
      $universityId: Int,
      $offerType: OfferType,
      $ownerType: [OwnerType!],
    ) {
      specialOffers(
        pageNumber: $pageNumber,
        pageSize: $pageSize,
        sortBy: $sortBy,
        sortDirection: $sortDirection,
        statuses: $statuses,
        internalTitle: $internalTitle,
        propertyId: $propertyId,
        cityId: $cityId,
        landlordId: $landlordId,
        universityId: $universityId,
        offerType: $offerType,
        ownerType: $ownerType,
      ) {
        pageInfo {
          numPages
        }
        totalCount
        edges {
          node {
            id
            title
            internalTitle
            createdAt
            notes
            startDate
            fulfillmentInstructions
            endDate
            description
            link
            amount
            maxBookings
            termsAndConditions
            exclusive
            ownerType
            locales
            offerType
            referralCode
            properties {
              edges {
                node {
                  slug
                  name
                  id
                  landlord {
                    name
                  }
                  unitTypes {
                    edges {
                      node {
                        id
                        name
                      }
                    }
                  }
                }
              }
            }
            listings {
              edges {
                node {
                  id
                  moveIn
                  moveOut
                  availableFrom
                  availableTo
                  minDuration
                  type
                  unitType {
                    id
                    name
                    property {
                      slug
                      id
                      name
                      landlord {
                        name
                      }
                      unitTypes {
                        edges {
                          node {
                            id
                            name
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            unitTypes {
              edges {
                node {
                  id
                  name
                  listings {
                    id
                    moveIn
                    moveOut
                    availableFrom
                    availableTo
                    minDuration
                    type
                  }
                  property {
                    slug
                    id
                    name
                    landlord {
                      name
                    }
                    unitTypes {
                      edges {
                        node {
                          id
                          name
                        }
                      }
                    }
                  }
                }
              }
            }
            cities {
              edges {
                node {
                  slug
                  name
                  id
                }
              }
            }
          }
        }
      }
    }
  `,
});

export const landlordOfferList = variables => ({
  operationName: 'listSpecialOffersForLandlord',
  variables,
  query: `query listSpecialOffersForLandlord($pageNumber: Int!, $pageSize: Int!, $sortBy: SpecialOfferSortBy, $sortDirection: SortDirection, $statuses: [SpecialOfferStatus!], $propertyId: Int, $cityId: Int, $title: String, $offerType: OfferType) {
    viewer {
      ... on LandlordContact {
        company {
          specialOffers(pageNumber: $pageNumber, pageSize: $pageSize, sortBy: $sortBy, sortDirection: $sortDirection, statuses: $statuses, propertyId: $propertyId, cityId: $cityId, title: $title, offerType: $offerType) {
            pageInfo {
              numPages
            }
            totalCount
            edges {
              node {
                id
                title
                createdAt
                notes
                startDate
                endDate
                description
                amount
                link
                locales
                offerType
                maxBookings
                termsAndConditions
                referralCode
                properties {
                  edges {
                    node {
                      slug
                      name
                      id
                      unitTypes {
                        edges {
                          node {
                            id
                            name
                            listings {
                              id
                              moveIn
                              moveOut
                              availableFrom
                              availableTo
                              minDuration
                              type
                            }
                          }
                        }
                      }
                    }
                  }
                }
                listings {
                  edges {
                    node {
                      id
                      moveIn
                      moveOut
                      availableFrom
                      availableTo
                      minDuration
                      type
                      unitType {
                        id
                        name
                        property {
                          slug
                          id
                          name
                          unitTypes {
                            edges {
                              node {
                                id
                                name
                                listings {
                                  id
                                  moveIn
                                  moveOut
                                  availableFrom
                                  availableTo
                                  minDuration
                                  type
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                unitTypes {
                  edges {
                    node {
                      id
                      name
                      listings {
                        id
                        moveIn
                        moveOut
                        availableFrom
                        availableTo
                        minDuration
                        type
                      }
                      property {
                        slug
                        id
                        name
                        unitTypes {
                          edges {
                            node {
                              id
                              name
                              listings {
                                id
                                moveIn
                                moveOut
                                availableFrom
                                availableTo
                                minDuration
                                type
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                cities {
                  edges {
                    node {
                      slug
                      name
                      id
                    }
                  }
                }
                universities {
                  edges {
                    node {
                      slug
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`,
});

export const getSpecialOffer = variables => ({
  operationName: 'GetSpecialOffer',
  variables,
  query: `query GetSpecialOffer($id: ID!) {
    node(id: $id) {
      ... on SpecialOffer {
        id
        title
        internalTitle
        createdAt
        notes
        startDate
        fulfillmentInstructions
        endDate
        description
        amount
        exclusive
        ownerType
        ipAddresses
        link
        locales
        offerType
        maxBookings
        termsAndConditions
        referralCode
        properties {
          edges {
            node {
              slug
              name
              id
              landlord {
                name
              }
              unitTypes {
                edges {
                  node {
                    id
                    name
                    listings {
                      id
                      moveIn
                      moveOut
                      availableFrom
                      availableTo
                      minDuration
                      type
                    }
                  }
                }
              }
            }
          }
        }
        listings {
          edges {
            node {
              id
              moveIn
              moveOut
              availableFrom
              availableTo
              minDuration
              type
              unitType {
                id
                name
                property {
                  slug
                  id
                  name
                  landlord {
                    name
                  }
                  unitTypes {
                    edges {
                      node {
                        id
                        name
                        listings {
                          id
                          moveIn
                          moveOut
                          availableFrom
                          availableTo
                          minDuration
                          type
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        unitTypes {
          edges {
            node {
              id
              name
              listings {
                id
                moveIn
                moveOut
                availableFrom
                availableTo
                minDuration
                type
              }
              property {
                slug
                id
                name
                landlord {
                  name
                }
                unitTypes {
                  edges {
                    node {
                      id
                      name
                      listings {
                        id
                        moveIn
                        moveOut
                        availableFrom
                        availableTo
                        minDuration
                        type
                      }
                    }
                  }
                }
              }
            }
          }
        }
        cities {
          edges {
            node {
              slug
              name
              id
            }
          }
        }
        universities {
          edges {
            node {
              slug
              name
            }
          }
        }
      }
    }
  }`,
});

export const searchProperties = variables => ({
  operationName: 'search',
  variables,
  query: `query search($query:String, $pageNumber: Int, $pageSize: Int  ) {
    search(query: $query, pageSize: $pageSize, pageNumber: $pageNumber, publishedStatus: PUBLISHED) {
      totalCount
      edges {
        node {
          ...on Property {
            name
            slug,
            id,
            city {
              name
            },
            unitTypes {
              edges {
                node {
                  id
                  name
                  listings {
                    id
                    moveIn
                    moveOut
                    availableFrom
                    availableTo
                    minDuration
                  }
                }
              }
            }
          }
        }
      }
    }
  }`,
});

export const searchLandlordProperties = variables => ({
  operationName: 'listPropertiesForLandlord',
  variables,
  query: `query listPropertiesForLandlord($pageNumber: Int!, $pageSize: Int!) {
    viewer {
      ... on LandlordContact {
        company {
          properties(pageNumber: $pageNumber, pageSize: $pageSize) {
            edges {
              node {
                name
                slug
                id
                city {
                  name
                }
                unitTypes {
                  edges {
                    node {
                      id
                      name
                      listings {
                        id
                        moveIn
                        moveOut
                        availableFrom
                        availableTo
                        minDuration
                        type
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`,
});

/**
 * {
 *  id: "sf-123ksdf",
 * }
 *
 * @param variables
 */
export const deleteSpecialOffer = variables => ({
  operationName: 'deleteSpecialOffer',
  variables: {
    input: variables,
  },
  query: `mutation deleteSpecialOffer($input: deleteSpecialOfferInput!) {
      deleteSpecialOffer(input: $input) {
        deleteSpecialOfferId
      }
    }`,
});

export const updateSpecialOffer = variables => ({
  operationName: 'updateSpecialOffer',
  variables: {
    input: variables,
  },
  query: `mutation updateSpecialOffer($input: updateSpecialOfferInput!) {
    updateSpecialOffer(input:$input) {
      specialOffer {
        id
        title
        internalTitle
        createdAt
        notes
        startDate
        ipAddresses
        fulfillmentInstructions
        endDate
        description
        amount
        link
        locales
        offerType
        maxBookings
        termsAndConditions
        referralCode
        properties {
          edges {
            node {
              slug
              id
              name
              unitTypes {
                edges {
                  node {
                    id
                    name
                    listings {
                      id
                      moveIn
                      moveOut
                      availableFrom
                      availableTo
                      minDuration
                      type
                    }
                  }
                }
              }
            }
          }
        }
        listings {
          edges {
            node {
              id
              moveIn
              moveOut
              availableFrom
              availableTo
              minDuration
              type
              unitType {
                id
                name
                property {
                  slug
                  id
                  name
                  unitTypes {
                    edges {
                      node {
                        id
                        name
                        listings {
                          id
                          moveIn
                          moveOut
                          availableFrom
                          availableTo
                          minDuration
                          type
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        unitTypes {
          edges {
            node {
              id
              name
              listings {
                id
                moveIn
                moveOut
                availableFrom
                availableTo
                minDuration
                type
              }
              property {
                slug
                id
                name
                unitTypes {
                  edges {
                    node {
                      id
                      name
                      listings {
                        id
                        moveIn
                        moveOut
                        availableFrom
                        availableTo
                        minDuration
                        type
                      }
                    }
                  }
                }
              }
            }
          }
        }
        cities {
          edges {
            node {
              slug
              name
              id
            }
          }
        }
        universities {
          edges {
            node {
              slug
              name
            }
          }
        }
      }
    }
  }`,
});
export const unLinkSpecialOffer = variables => ({
  operationName: 'unLinkSpecialOffer',
  variables: { input: variables },
  query: `mutation unLinkSpecialOffer($input: unLinkSpecialOfferInput!) {
    unLinkSpecialOffer(input:$input) {
      specialOffer {
        id
        title
        internalTitle
        createdAt
        notes
        startDate
        fulfillmentInstructions
        endDate
        description
        amount
        link
        locales
        offerType
        maxBookings
        termsAndConditions
        referralCode
        properties {
          edges {
            node {
              slug
              id
              name
              unitTypes {
                edges {
                  node {
                    id
                    name
                    listings {
                      id
                      moveIn
                      moveOut
                      availableFrom
                      availableTo
                      minDuration
                      type
                    }
                  }
                }
              }
            }
          }
        }
        listings {
          edges {
            node {
              id
              moveIn
              moveOut
              availableFrom
              availableTo
              minDuration
              type
              unitType {
                id
                name
                property {
                  slug
                  id
                  name
                  unitTypes {
                    edges {
                      node {
                        id
                        name
                        listings {
                          id
                          moveIn
                          moveOut
                          availableFrom
                          availableTo
                          minDuration
                          type
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        unitTypes {
          edges {
            node {
              id
              name
              listings {
                id
                moveIn
                moveOut
                availableFrom
                availableTo
                minDuration
                type
              }
              property {
                slug
                id
                name
                unitTypes {
                  edges {
                    node {
                      id
                      name
                      listings {
                        id
                        moveIn
                        moveOut
                        availableFrom
                        availableTo
                        minDuration
                        type
                      }
                    }
                  }
                }
              }
            }
          }
        }
        cities {
          edges {
            node {
              slug
              name
              id
            }
          }
        }
        universities {
          edges {
            node {
              slug
              name
            }
          }
        }
      }
    }
  }`,
});

export const createSpecialOffer = variables => ({
  operationName: 'createSpecialOffer',
  variables: {
    input: variables,
  },
  query: `mutation createSpecialOffer($input: createSpecialOfferInput!) {
    createSpecialOffer(input: $input) {
      specialOffer {
        id
        title
        internalTitle
        createdAt
        notes
        startDate
        fulfillmentInstructions
        endDate
        description
        amount
        link
        locales
        offerType
        maxBookings
        termsAndConditions
        referralCode
        properties {
          edges {
            node {
              slug
              id
              name
              unitTypes {
                edges {
                  node {
                    id
                    name
                    listings {
                      id
                      moveIn
                      moveOut
                      availableFrom
                      availableTo
                      minDuration
                      type
                    }
                  }
                }
              }
            }
          }
        }
        listings {
          edges {
            node {
              id
              moveIn
              moveOut
              availableFrom
              availableTo
              minDuration
              type
              unitType {
                id
                name
                property {
                  slug
                  id
                  name
                  unitTypes {
                    edges {
                      node {
                        id
                        name
                        listings {
                          id
                          moveIn
                          moveOut
                          availableFrom
                          availableTo
                          minDuration
                          type
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        unitTypes {
          edges {
            node {
              id
              name
              listings {
                id
                moveIn
                moveOut
                availableFrom
                availableTo
                minDuration
                type
              }
              property {
                slug
                id
                name
                unitTypes {
                  edges {
                    node {
                      id
                      name
                      listings {
                        id
                        moveIn
                        moveOut
                        availableFrom
                        availableTo
                        minDuration
                        type
                      }
                    }
                  }
                }
              }
            }
          }
        }
        cities {
          edges {
            node {
              slug
              name
              id
            }
          }
        }
        universities {
          edges {
            node {
              slug
              name
            }
          }
        }
      }
    }
  }`,
});

export const linkSpecialOffer = variables => ({
  operationName: 'linkSpecialOffer',
  variables: {
    input: variables,
  },
  query: `mutation linkSpecialOffer($input: linkSpecialOfferInput!) {
    linkSpecialOffer(input:$input) {
      specialOffer {
        id
        title
        internalTitle
        createdAt
        notes
        startDate
        fulfillmentInstructions
        endDate
        description
        amount
        link
        locales
        offerType
        maxBookings
        termsAndConditions
        referralCode
        properties {
          edges {
            node {
              slug
              id
              name
              unitTypes {
                edges {
                  node {
                    id
                    name
                    listings {
                      id
                      moveIn
                      moveOut
                      availableFrom
                      availableTo
                      minDuration
                      type
                    }
                  }
                }
              }
            }
          }
        }
        listings {
          edges {
            node {
              id
              moveIn
              moveOut
              availableFrom
              availableTo
              minDuration
              type
              unitType {
                id
                name
                property {
                  slug
                  id
                  name
                  unitTypes {
                    edges {
                      node {
                        id
                        name
                        listings {
                          id
                          moveIn
                          moveOut
                          availableFrom
                          availableTo
                          minDuration
                          type
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        unitTypes {
          edges {
            node {
              id
              name
              listings {
                id
                moveIn
                moveOut
                availableFrom
                availableTo
                minDuration
                type
              }
              property {
                slug
                id
                name
                unitTypes {
                  edges {
                    node {
                      id
                      name
                      listings {
                        id
                        moveIn
                        moveOut
                        availableFrom
                        availableTo
                        minDuration
                        type
                      }
                    }
                  }
                }
              }
            }
          }
        }
        cities {
          edges {
            node {
              slug
              name
              id
            }
          }
        }
        universities {
          edges {
            node {
              slug
              name
            }
          }
        }
      }
    }
  }`,
});

export const classificationList = variables => ({
  operationName: 'CMS_ClassificationList',
  variables,
  query: `
    query CMS_ClassificationList(
      $propertySlug: String,
      $pageNumber: Int!,
      $pageSize: Int!,
      $sortBy: ClassificationSortBy,
      $sortDirection: SortDirection
    ) {
      property(slug: $propertySlug){
        id
        name
        slug
        classifications(
          pageNumber: $pageNumber,
          pageSize: $pageSize,
          sortBy: $sortBy,
          sortDirection: $sortDirection
        ) {
          totalCount
          edges {
            node {
              id
              name
              updatedAt
              unitTypes {
                id
                name
              }
            }
          }
        }
        unitTypes(pageNumber: 1, pageSize: 9999) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }`,
});

/**
 * {
 *  propertyId: "sf-123ksdf",
 *  name: "sdfks fjas"
 * }
 *
 * @param variables
 */
export const createClassification = variables => ({
  operationName: 'CMS_CreateClassification',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreateClassification($input: CreateClassificationInput!) {
      createClassification(input: $input) {
        classification {
          id
          name
          updatedAt
        }
      }
    }`,
});

/**
 * {
 *  id: "sf-123sdfsdfsd23423ksdf",
 *  name: "sdfks fjas"
 * }
 *
 * @param variables
 */
export const updateClassification = variables => ({
  operationName: 'CMS_UpdateClassification',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateClassification($input: UpdateClassificationInput!) {
      updateClassification(input: $input) {
        classification {
          id
          name
          updatedAt
        }
      }
    }`,
});

/**
 * {
 *  id: "sf-123ksdf",
 * }
 *
 * @param variables
 */
export const deleteClassification = variables => ({
  operationName: 'CMS_DeleteClassification',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_DeleteClassification($input: DeleteClassificationInput!) {
      deleteClassification(input: $input) {
        deletedClassificationId
      }
    }`,
});

/**
 * {
 *  "classificationId": "sfkasdf-234123",
 *  "unitTypeId": "sdf39-943k34nf"
 * }
 * @param variables
 */
export const addClassificationToUnitType = variables => ({
  operationName: 'CMS_AddClassificationToUnitType',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_AddClassificationToUnitType($input: AddClassificationToUnitTypeInput!) {
      addClassificationToUnitType(input: $input) {
        classification {
          id
          unitTypes {
            id
            name
          }
        }
      }
    }`,
});

/**
 * {
 *  "classificationId": "sfkasdf-234123",
 *  "unitTypeId": "sdf39-943k34nf"
 * }
 * @param variables
 */
export const removeClassificationFromUnitType = variables => ({
  operationName: 'CMS_RemoveClassificationFromUnitType',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_RemoveClassificationFromUnitType($input: RemoveClassificationFromUnitTypeInput!) {
      removeClassificationFromUnitType(input: $input) {
        classification {
          id
          unitTypes {
            id
            name
          }
        }
      }
    }`,
});

/**
 *
 * @param variables
 */
export const distinctionsList = variables => ({
  operationName: 'CMS_DistinctionsList',
  variables,
  query: `
    query CMS_DistinctionsList(
      $propertySlug: String,
      $pageNumber: Int!,
      $pageSize: Int!,
      $sortBy: PropertyDistinctionSortBy,
      $sortDirection: SortDirection,
      $typeIds: [ID!]
    ) {
      property(slug: $propertySlug){
        id
        name
        slug
        propertyDistinctions(
          pageNumber: $pageNumber,
          pageSize: $pageSize,
          sortBy: $sortBy,
          sortDirection: $sortDirection,
          typeIds: $typeIds
        ) {
          totalCount
          edges {
            node {
              id
              distinction {
                id
                name
                type {
                  id
                  name
                }
              }
              landlordValue
              updatedAt
              unitTypes {
                id
                name
              }
            }
          }
        }
        unitTypes(pageNumber: 1, pageSize: 9999) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
      distinctionTypes {
        id
        name
        distinctions {
          id
          name
        }
      }
    }`,
});

/**
 * {
 *  propertyId: "sdfsdfs990-12312",
 *  distinctionId: "mkwler44-dfgdf",
 *  landlordValue: "good distinction"
 * }
 * @param variables
 */
export const createDistinction = variables => ({
  operationName: 'CMS_CreatePropertyDistinction',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreatePropertyDistinction($input: CreatePropertyDistinctionInput) {
      createPropertyDistinction(input: $input) {
        propertyDistinction {
          id
          landlordValue
        }
      }
    }`,
});

/**
 * {
 *  id: "sdfsdfs990-1232",
 *  distinctionId: "mkwler44-dfgdf",
 *  landlordValue: "good distinction"
 * }
 * @param variables
 */
export const updateDistinction = variables => ({
  operationName: 'CMS_UpdatePropertyDistinction',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdatePropertyDistinction($input: UpdatePropertyDistinctionInput!) {
      updatePropertyDistinction(input: $input) {
        propertyDistinction {
          id
          landlordValue
        }
      }
    }`,
});

/**
 * {
 *  id: "sdfsdfs990-123"
 * }
 * @param variables
 */
export const deleteDistinction = variables => ({
  operationName: 'CMS_DeletePropertyDistinction',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_DeletePropertyDistinction($input: DeletePropertyDistinctionInput!) {
      deletePropertyDistinction(input: $input) {
        deletedPropertyDistinctionId
      }
    }`,
});

/**
 * {
 *  "propertyDistinctionId": "sfkasdf-234123",
 *  "unitTypeId": "sdf39-943k34nf"
 * }
 * @param variables
 */
export const addPropertyDistinctionToUnitType = variables => ({
  operationName: 'CMS_AddPropertyDistinctionToUnitTypes',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_AddPropertyDistinctionToUnitTypes($input: AddPropertyDistinctionToUnitTypeInput!) {
      addPropertyDistinctionToUnitType(input: $input) {
        propertyDistinction {
          id
          unitTypes {
            id
            name
          }
        }
      }
    }`,
});

/**
 * {
 *  "propertyDistinctionId": "sfkasdf-234123",
 *  "unitTypeId": "sdf39-943k34nf"
 * }
 * @param variables
 */
export const removePropertyDistinctionFromUnitType = variables => ({
  operationName: 'CMS_RemovePropertyDistinctionFromUnitTypes',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_RemovePropertyDistinctionFromUnitTypes($input: RemovePropertyDistinctionFromUnitTypeInput!) {
      removePropertyDistinctionFromUnitType(input: $input) {
        propertyDistinction {
          id
          unitTypes {
            id
            name
          }
        }
      }
    }`,
});

export const roomListing = variables => ({
  operationName: 'CMS_RoomListing',
  variables,
  query: `
    query CMS_RoomListing(
      $propertySlug: String,
      $pageNumber: Int!,
      $pageSize: Int!,
      $sortBy: ListingSortBy,
      $sortDirection: SortDirection,
      $unitTypeIds: [ID!],
      $availabilities: [Availability!]
      $hasListing: Boolean
    ) {
      property(slug: $propertySlug){
        id
        name
        slug
        currency
        billingCycle
        listings(
          defaultSortRule : FIXED_OR_WAITING_LIST_TOP,
          pageNumber: $pageNumber,
          pageSize: $pageSize,
          sortBy: $sortBy,
          sortDirection: $sortDirection,
          unitTypeIds: $unitTypeIds,
          availabilities: $availabilities
        ) {
          totalCount
          edges {
            node {
              id
              unitType {
                id
                name
              }
              type
              availableFrom
              availableTo
              discountType
              discountValue
              moveIn
              moveOut
              minDuration
              priceMin
              priceMax
              availability
              liveOn
              liveUntil
              autoPriceAllowed
              autoAvailAllowed
              updatedAt
            }
          }
        }
        unitTypes(pageNumber:1, pageSize:9999, hasListing: $hasListing) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }`,
});

/**
 * {
 *  "autoAvailAllowed": false,
 *   "autoPriceAllowed": false,
 *   "availability": "GOOD",
 *   "liveOn": "2017-09-01",
 *   "liveUntil": "2017-09-02",
 *   "maxPrice": 123,
 *   "minPrice": 111,
 *   "moveIn": "2017-09-01",
 *   "moveOut": "2017-09-02",
 *   "type": "FIXED",
 *   "unitTypeId": "4cafa23d-3672-4d53-8168-c9a8b9890e86"
 *  }
 * @param variables
 */
export const createRoomListing = variables => ({
  operationName: 'CMS_CreateRoomListing',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreateRoomListing($input: CreateListingInput!) {
      createListing(input: $input) {
        listing {
          id
          type
        }
      }
    }`,
});

/**
 * {
 *   "listingId": "sdfjskdfs",
 *   "autoAvailAllowed": false,
 *   "autoPriceAllowed": false,
 *   "availability": "GOOD",
 *   "liveOn": "2017-09-01",
 *   "liveUntil": "2017-09-02",
 *   "maxPrice": 123,
 *   "minPrice": 111,
 *   "moveIn": "2017-09-01",
 *   "moveOut": "2017-09-02",
 *   "type": "FIXED"
 * }
 * @param variables
 */
export const updateRoomListing = variables => ({
  operationName: 'CMS_UpdateRoomListing',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateRoomListing($input: UpdateListingInput!) {
      updateListing(input: $input) {
        listing {
          id
          type
        }
      }
    }`,
});

/**
 * {
 *  "id": "sdf-123j123"
 * }
 * @param variables
 */
export const deleteRoomListing = variables => ({
  operationName: 'CMS_DeleteRoomListing',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_DeleteRoomListing($input: DeleteListingInput!) {
      deleteListing(input: $input) {
        deletedListingId
      }
    }`,
});

export const search = (variables, type) => {
  let query = `
    ... on Property {
      type: __typename
      slug
      name
      status,
      id
      city {
        name
        id
        country {
          name
        }
      }
    },
    ... on Country {
      type: __typename
      slug
      name
      id
    },
    ... on City {
      type: __typename
      slug
      id
      name
      published
      country {
        name
      }
    },
    ... on Landlord {
      type: __typename
      slug
      id
      name
    }`;

  if (type && type !== 'city') {
    query = `
      ... on ${type[0].toUpperCase() + type.slice(1)} {
        type: __typename
        slug
        name
        id
      }`;
  }

  if (type && type === 'city') {
    query = `
      ... on ${type[0].toUpperCase() + type.slice(1)} {
        type: __typename
        slug
        name
        id
        published
        country {
          name
          currencyCode
          billingCycle
        }
      }`;
  }

  return {
    operationName: 'CMS_Search',
    variables,
    query: `
      query CMS_Search($query: String, $pageNumber: Int, $pageSize: Int) {
        search(query: $query, pageNumber: $pageNumber, pageSize: $pageSize, publishedStatus: ALL) {
          totalCount
          edges {
            node {
              ${query}
            }
          }
        }
      }
    `,
  };
};

export const searchUniversity = variables => ({
  operationName: 'CMS_Search',
  variables,
  query: `
    query CMS_Search($query: String, $pageNumber: Int, $pageSize: Int) {
      search(query: $query, pageNumber: $pageNumber, pageSize: $pageSize, publishedStatus: PUBLISHED) {
        totalCount
        edges {
          node {
            ... on University{
              id
              published
              name
              slug
            }
          }
        }
      }
    }
  `,
});

export const studentDetail = variables => ({
  operationName: 'UDESK_StudentDetail',
  variables,
  query: `
    query UDESK_StudentDetail(
      $userUuid: String,
      $wechatId: String,
      $phone: String,
    ) {
      getStudentDetails(
        userUuid: $userUuid,
        wechatId: $wechatId,
        phone: $phone
      ){
        userUuid
        firstName
        lastName
        language
        nationality
        emailAddress
        phoneNumber
        destinationUniversity
      }
    }`,
});

export const checkPropertySlug = variables => ({
  operationName: 'CMS_PropertySlugCheck',
  variables,
  query: `
  query CMS_PropertySlugCheck(
    $slug: String,
  ) {
    property(
      slug: $slug,
    ) {
      id
      slug
      name
    }
  }
  `,
});

export const getPropertyDetail = variables => ({
  operationName: 'CMS_PropertyDetail',
  variables,
  query: `
    query CMS_PropertyDetail(
    $slug: String,
    $draftSize: PositiveInteger = 9999,
    ) {
      property(
      slug: $slug,
      ) {
        offlinePaymentMethod {
          id
          instruction
          data
          methodType
        }
        integrated
        publishCondition {
          commissionTier
          contractStage
          image
          listing
          paymentPlan
          payout
          offlinePaymentMethod
        }
        externalSystem
        externalId
        apCategory
        country
        bookingJourney
        contractStage
        propertyType {
          name
        }
        residentType
        publishCondition {
          commissionTier
          contractStage
          paymentPlan
          payout
        }
        contracts {
          id
        }
        commissionTiers {
          id
          status
        }
        documentations {
          check
          label
          name
          slug
        }
        destinationUniversities {
          id
          name
        }
        drafts(
        sortBy: UPDATED_AT,
        pageNumber: 1,
        pageSize: $draftSize,
        statuses: [PENDING, REJECTED, EXPIRED],
        ) {
          edges {
            node {
              id
              status
              updatedAt
              changes
              category
              createdUser {
                firstName
                lastName
                email
              }
              comments {
                comment
                id
                section
              }
              image {
                id
                discriminator
                category
                size
                extension
                contentType
                hero
                path
                position
                source
                filename
                imageHash
                status
                unitTypeId
              }
              video {
                id
                path
                transcodedStatus
                links {
                  hls
                  hqMp4
                  lqMp4
                  thumbnail
                }
                locales
                category
                position
                size
                unitTypeId
                videoHash
                fileName
                extension
                transcodeJobId
                transcodeJobStatus
                status
              }
              propertyLink {
                area
                displayRegion
                id
                link
                type
                propertyId
                status
              }
              unitTypeLink {
                displayRegion
                id
                link
                type
                status
                unitTypeId
              }
            }
          }
        }
        universities {
          name
          slug
          id
        }
        name
        slug
        id
        floorPlans {
          specificFloorPlans {
            id
            floorIndex
            block
            floorPlanImages {
              imageHash
              filename
              id
              discriminator
              category
              size
              extension
              contentType
              hero
              path
              position
              source
              status
              unitTypeId
              width
              height
            }
          }
          generalFloorPlanImages {
            imageHash
            filename
            id
            discriminator
            category
            size
            extension
            contentType
            hero
            path
            position
            source
            status
            unitTypeId
            width
            height
          }
        }
        noPlaceNoPay
        noVisaNoPay
        tenancyAgreement {
          calculateType
          field
          timeType
          unit
          value
          id
        }
        city {
          name
          longitude
          latitude
          id
          slug
          country {
            name
            slug
          }
          areas {
            totalCount
            edges {
              node {
                id
                name
                slug
                originalName
              }
            }
          }
          published
        }
        profile {
          lastSyncTime
        }
        status
        currency
        billingCycle
        address
        addressLine2
        shippingCity
        zipCode
        area {
          id,
          name
        }
        latitude
        longitude
        allLinks {
          area
          displayRegion
          id
          link
          type
          propertyId
          status
        }
        feedControlled
        description
        descriptionCn
        headline
        headlineCn
        minPrice
        facilities(version: "v2") {
          label
          slug
          group
          checked
          rank
          tags
        }
        cancellationChecked
        covid19Policy
        cancellationProcess
        cancellationPeriodValue
        cancellationPeriodType
        totalBeds
        landlord {
          id
          name
          slug
          contractStage
          autoUpdate
        }
        address
        rank
        rankWeight
        bookingType
        contractStage
        allVideos {
          id
          path
          transcodedStatus
          links {
            hls
            hqMp4
            lqMp4
            thumbnail
          }
          locales
          category
          position
          size
          unitTypeId
          videoHash
          fileName
          extension
          transcodeJobId
          transcodeJobStatus
          status
        }
        allImages {
          edges {
            node {
              id
              discriminator
              category
              height
              width
              size
              extension
              contentType
              hero
              path
              position
              source
              filename
              imageHash
              status
            }
          }
        }
        unitTypes {
          edges {
            node {
              id
              name
              category
              roomSize
              roomType
              viewType
              bedCount
              kitchenArrangement
              maxOccupancy
              dualOccupancy
              bathroomType
              floors
              bedSizeType
              inventoryType
              unitTypeBedSizes {
                id
                type
                length
                width
                bedCount
              }
              facilities(version: "v2") {
                slug
                label
                group
                checked
              }
              lastFurnished
              bedroomCountMin
              bedroomCountMax
              bedCount
              bathroomCount
              kitchenCount
              genderMix
              dietaryPreference
              smokingPreference
              genderMix
              smokingPreference
              dietaryPreference
              updatedAt
              allLinks {
                displayRegion
                id
                link
                type
                unitTypeId
                status
              }
              listings(defaultSortRule: FIXED_OR_WAITING_LIST_TOP) {
                id
                type
                priceMin
                priceMax
                tenancyLengthType
                tenancyLengthValue
                availability
                liveOn
                liveUntil
                autoPriceAllowed
                autoAvailAllowed
                inventoryCount
                discountType
                discountValue
                updatedAt
                moveIn
                moveInType
                moveOut
                moveOutType
                fixed
                availableThoughMoveInDatePassed
                turnaroundType
                turnaroundTime
              }
              allVideos {
                id
                path
                transcodedStatus
                links {
                  hls
                  hqMp4
                  lqMp4
                  thumbnail
                }
                category
                locales
                position
                size
                unitTypeId
                videoHash
                fileName
                extension
                transcodeJobId
                transcodeJobStatus
                status
              }
              allImages {
                edges {
                  node {
                    id
                    discriminator
                    height
                    width
                    size
                    extension
                    contentType
                    hero
                    path
                    position
                    source
                    filename
                    imageHash
                    status
                  }
                }
              }
            }
          }
        }
        confirmDueHours
        paymentDueHours
        paymentPlan {
          paymentOnline
          category
          currency
          description
          endDate
          id
          hasIntegratedProperty
          landlordId
          landlord {
            id
          }
          name
          properties {
            id
            name
            slug
            status
            bookingJourney
          }
          startDate
          deposits {
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
            createdAt
          }
          fees {
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
            createdAt
          }
          instalments {
            country {
              name
            }
            createdAt
            fromTenancy
            id
            payMonthly
            payQuarterly
            payWeekly
            payRemainderAtOnce
            fullPayment
            name
            paymentPlanId
            requireGuarantor
            tenancyUnit
            toTenancy
            payNowAmount
            updatedAt
          }
        }
        priceCalculationRuleSetting {
          priceCalculationRule {
            id
            propertyId
            type
            billingCycle
            calculateMethod
            dailyPriceType
            customLength
            moveInStart
            moveInEnd
            moveInType
            moveOutType
            moveOutStart
            moveOutEnd
          }
          allBillingCycleRule {
            monthly {
              dailyPriceType
              customLength
            }
            weekly {
              dailyPriceType
              customLength
            }
          }
        }
      }
    }
  `,
});

export const getPropertyComments = variables => ({
  operationName: 'CMS_PropertyComments',
  variables,
  query: `
  query CMS_PropertyComments(
    $slug: String,
  ) {
    property(
      slug: $slug,
    ) {
      drafts(
        sortBy: UPDATED_AT,
        pageNumber: 1,
        pageSize: 9999,
        statuses: [PENDING, REJECTED, EXPIRED],
      ) {
        edges {
          node {
            id
            status
            updatedAt
            changes
            category
            createdUser {
              firstName
              lastName
              email
            }
            comments {
              comment
              id
              section
            }
            image {
              id
              discriminator
              category
              size
              extension
              contentType
              hero
              path
              position
              source
              filename
              imageHash
              status
              unitTypeId
            }
            video {
              id
              path
              transcodedStatus
              links {
                hls
                hqMp4
                lqMp4
                thumbnail
              }
              locales
              category
              position
              size
              unitTypeId
              videoHash
              fileName
              extension
              transcodeJobId
              transcodeJobStatus
              status
            }
            propertyLink {
              area
              displayRegion
              id
              link
              type
              propertyId
              status
            }
            unitTypeLink {
              displayRegion
              id
              link
              type
              status
              unitTypeId
            }
          }
        }
      }
    }
  }
  `,
});

// "input": {
//   "id": "eyJpZCI6IDEsICJ0eXBlIjogIlByb3BlcnR5In0=",
//   "name": "name",
//   "slug": "name_slug",
//   "totalBeds": 100,
//   "descriptionEn": "descriptionEn",
//   "description": "description",
//   "freeCancellationPeriod": "freeCancellationPeriod",
//   "cancellationProcess": "cancellationProcess",
//   "address": "address",
//   "addressLine_2": "addressLine_2",
//   "postalCode": "postalCode",
//   "areaId": 1,
//   "latitude": 1.1,
//   "longitude": 1.2,
//   "url": "www.baidu.com",
//   "landlordPhotograpyUrl": "www.baidu.com",
//   "roomMatrixUrl": "www.baidu.com",
//   "rank": 10,
//   "rankWeight": 10,
//   "rankType": "STAR",
//   "links": [
//     {
//       "link": "www.student.com",
//       "type": "vr",
//       "displayRegion": "ALL",
//       "enabled": true
//     }
//   ],
//   "contacts": [
//       {
//       "contactName": "contact_name_2",
//       "contactPhone": "contact_phone",
//       "contactEmail": "contact_email"
//     }
//   ],
//   "facilities": [
//         {
//           "slug":"wifi"
//     },
//     {
//           "slug":"cooking_facilities"
//     }
//       ]
//    }
export const updateProperty = variables => ({
  operationName: 'CMS_UpdateProperty',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateProperty($input: UpdatePropertyInput!) {
      updateProperty (input:$input) {
        property {
          universities {
            name
            slug
            id
          }
          name
          slug
          id
          status
          currency
          billingCycle
          address
          addressLine2
          zipCode
          tenancyAgreement {
            calculateType
            field
            timeType
            unit
            value
            id
          }
          area{
            id,
            name
          }
          drafts {
            edges {
              node {
                id
                status
              }
            }
          }
          latitude
          longitude
          links {
            area
            displayRegion
            enabled
            id
            link
            type
            label
            propertyId
          }
          feedControlled
          description
          descriptionCn
          headline
          headlineCn
          minPrice
          facilities(version: "v2") {
            label
            slug
            group
            checked
            rank
            tags
          }
          cancellationChecked
          cancellationProcess
          cancellationPeriodValue
          cancellationPeriodType
          totalBeds
          landlord {
            name
          }
          address
          shippingCity
          url
          landlordPhotograpyUrl
          roomMatrixUrl
          rank
          rankWeight
          bookingType
          propertyContacts {
            id
            contactName
            contactPhone
            contactEmail
          }
          contentContactName
          videos {
            id
            path
            transcodedStatus
            links {
              hls
              hqMp4
              lqMp4
              thumbnail
            }
            category
            locales
            position
            size
            unitTypeId
            videoHash
            extension
            transcodeJobId
            transcodeJobStatus
          }
          images {
            edges {
              node {
                id
                discriminator
                category
                height
                width
                size
                extension
                contentType
                hero
                path
                position
                source
                filename
                imageHash
              }
            }
          }
          unitTypes {
            edges{
              node {
                id
                name
                category
                roomSize
                roomType
                viewType
                bedCount
                kitchenArrangement
                maxOccupancy
                dualOccupancy
                bathroomType
                floors
                bedSizeType
                unitTypeBedSizes{
                  id
                  type
                  length
                  width
                  bedCount
                }
                facilities(version: "v2") {
                  slug
                  label
                  group
                  checked
                }
                lastFurnished
                bedroomCountMin
                bedroomCountMax
                bedCount
                bathroomCount
                kitchenCount
                genderMix
                dietaryPreference
                smokingPreference
                genderMix
                smokingPreference
                dietaryPreference
                updatedAt
                links {
                  displayRegion
                  enabled
                  id
                  link
                  type
                  unitTypeId
                }
                listings {
                  id
                  type
                  priceMin
                  priceMax
                  tenancyLengthType
                  tenancyLengthValue
                  availability
                  liveOn
                  liveUntil
                  autoPriceAllowed
                  autoAvailAllowed
                  discountType
                  discountValue
                  updatedAt
                  moveIn
                  moveInType
                  moveOut
                  moveOutType
                  fixed
                  availableThoughMoveInDatePassed
                }
                videos {
                  id
                  path
                  transcodedStatus
                  links {
                    hls
                    hqMp4
                    lqMp4
                    thumbnail
                  }
                  category
                  locales
                  position
                  size
                  unitTypeId
                  videoHash
                  extension
                  transcodeJobId
                  transcodeJobStatus
                }
                images {
                  edges {
                    node {
                      id
                      discriminator
                      height
                      width
                      size
                      extension
                      contentType
                      hero
                      path
                      position
                      source
                      filename
                      imageHash
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
});

export const publishProperty = variables => ({
  operationName: 'CMS_PublishProperty',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_PublishProperty($input: PublishPropertyInput!) {
      publishProperty(input: $input) {
        status
        statusCode
        error
        description
      }
    }
  `,
});

export const getPropertyNote = variables => ({
  operationName: 'CMS_PropertyNote',
  variables,
  query: `
  query CMS_PropertyNote(
    $slug: String,
  ) {
    property(
      slug: $slug,
    ) {
    name
    slug
    id
    city {
      slug
      country {
        slug
      }
    }
    notes {
      id
      propertyId
      updatedBy
      oldContractStage
      newContractStage
      updatedUser {
        firstName
        lastName
      }
      title
      description
      createdAt
      updatedAt
    }
    contracts {
      files {
        contentType
        contractId
        createdAt
        id
        name
        source
        updatedAt
      }
    }
    landlord {
        id
        slug
        contracts {
          edges {
            node {
              id
              signedDate
              effectiveFrom
              effectiveTo
              files {
                id
                name
                source
                updatedAt
                contentType
                contractId
                createdAt
              }
            }
          }
        }
      }
    status
    contractStage
    }
  }
  `,
});

export const getPropertyDepositePayment = variables => ({
  operationName: 'CMS_PropertyDetail',
  variables,
  query: `
  query CMS_PropertyDetail(
    $slug: String,
  ) {
    property(
      slug: $slug,
    ) {
    name
    slug
    id
    city {
      slug
      country {
        slug
      }
    }
    acceptsDepositPayment
    paymentsEnabled
    paymentProcess
    status
    paymentDepositRules {
      edges{
        node{
          firstInstalment
          id
          name
          paymentProcessingFee
          type
          value
          updatedAt
        }
      }
    }
    }
  }
  `,
});

export const getPropertyCommissionTiers = variables => ({
  operationName: 'CMS_PropertyCommissionTiers',
  variables,
  query: `
  query CMS_PropertyCommissionTiers(
    $slug: String,
  ) {
    property(
      slug: $slug,
    ) {
      name
      slug
      id
      currency
      city {
        slug
        country {
          slug
        }
      }
      bookingJourney
      allCommissionTiers {
       
      landlordLevel {
        bonus
        bookingCountFrom
        bookingCountTo
        bookingJourney
        capType
        capValue
        category
        checkInDateFrom
        checkInDateTo
        convertedCalculationValue
        currencyValues
        description
        effectiveFrom
        effectiveTo
        fullyCalculatable
        id 
        name
        percentageForReport
        retrospectiveCommission
        status
        tenancyLengthFrom
        tenancyLengthTo
        tenancyUnit
        triggerPoint
        type
        unitTypes {
          id
          name
        }
        updatedAt
        validPeriod
        value
      }
      platformLevel {
        bonus
        bookingCountFrom
        bookingCountTo
        bookingJourney
        capType
        capValue
        category
        checkInDateFrom
        checkInDateTo
        convertedCalculationValue
        currencyValues
        currency
        description
        effectiveFrom
        effectiveTo
        fullyCalculatable
        id 
        name
        percentageForReport
        retrospectiveCommission
        status
        tenancyLengthFrom
        tenancyLengthTo
        tenancyUnit
        triggerPoint
        type
        unitTypes {
          id
          name
        }
        updatedAt
        validPeriod
        value
      }
      propertyLevel {
        bonus
        bookingCountFrom
        bookingCountTo
        bookingJourney
        capType
        capValue
        category
        checkInDateFrom
        checkInDateTo
        convertedCalculationValue
        currencyValues
        description
        effectiveFrom
        effectiveTo
        fullyCalculatable
        id
      
        name
        percentageForReport
        retrospectiveCommission
        status
        tenancyLengthFrom
        tenancyLengthTo
        tenancyUnit
        triggerPoint
        type
        unitTypes {
          id
          name
        }
        updatedAt
        validPeriod
        value
      }
}
    }
  }
  `,
});

export const queryCity = variables => ({
  operationName: 'CMS_QueryCity',
  variables,
  query: `
  query CMS_QueryCity($slug: String){
    city(slug: $slug){
      id
      name
      slug
    }
  }`,
});

export const queryCountry = variables => ({
  operationName: 'CMS_QueryCountry',
  variables,
  query: `
  query CMS_QueryCountry($slug: String){
    country(slug: $slug){
      id
      name
      slug
    }
  }`,
});
export const queryLandlord = variables => ({
  operationName: 'CMS_QueryLandlord',
  variables,
  query: `
  query CMS_QueryLandlord($slug: String){
    landlord(slug: $slug){
      id
      name
      slug
    }
  }`,
});

/**
 * {
 *  "pageNumber": 1,
 *   "pageSize": 20,
 *   "sortBy": "slug",
 *   "sortDirection": "ASCENDING",
 *   "countrySlugs": ['ta'],
 *   "billingCycle": [WEEKLY],
 *  }
 * @param variables
 */

export const countries = variables => ({
  operationName: 'CMS_CountriesView',
  variables,
  query: `
    query CMS_CountriesView(
      $pageNumber: Int!,
      $pageSize: Int!,
      $countrySlugs: [String!],
      $billingCycle: [BillingCycle!],
      $sortBy: CountrySortBy,
      $sortDirection: SortDirection,
    ) {
      countries(
      pageNumber: $pageNumber,
      pageSize: $pageSize,
      countrySlugs: $countrySlugs,
      billingCycle: $billingCycle,
      sortBy: $sortBy,
      sortDirection: $sortDirection,
      publishedStatus: ALL
    ) {
      pageInfo {
        numPages
      }
      totalCount
      edges {
        node {
          billingCycle
          countryCode
          currencyCode
          id
          name
          originalName
          slug
          properties
          publishedProperties
        }
      }
    }
  }`,
});

export const noPropertiescountries = variables => ({
  operationName: 'CMS_NoPropertiesCountriesView',
  variables,
  query: `
    query CMS_NoPropertiesCountriesView(
      $pageNumber: Int!,
      $pageSize: Int!,
      $sortBy: CountrySortBy,
      $sortDirection: SortDirection,
    ) {
      countries(
      pageNumber: $pageNumber,
      pageSize: $pageSize,
      sortBy: $sortBy,
      sortDirection: $sortDirection,
    ) {
      pageInfo {
        numPages
      }
      totalCount
      edges {
        node {
          id
          name
          originalName
          slug
        }
      }
    }
  }`,
});

/**
 * {
 *   "slug": "slug",
 *  }
 * @param variables
 */

export const city = variables => ({
  operationName: 'CMS_CityView',
  variables,
  query: `
    query CMS_CityView(
      $slug: String,
    ) {
      city(
      slug: $slug,
    ) {
      id
      name
      areas(pageNumber: 1,pageSize: 10){
        totalCount
      }
      universities(pageNumber: 1,pageSize: 10){
        totalCount
      }
      properties
      country {
        name
        slug
      }
      areas(pageNumber: 1,pageSize: 10){
        totalCount
      }
      universities(pageNumber: 1,pageSize: 10){
        totalCount
      }
      slug
      published
      latitude
      longitude
      headline
      summary
      rank
      publishedProperties
      heroImage {
        id
        filename
        extension
        imageHash
        source
      }
      smallHeroImage {
        id
        filename
        extension
        imageHash
        source
      }
      seoTemplate {
        metaDescription
        metaKeywords
        metaTitle
        srpIntroHeadline
        srpIntroParagraph
      }
      srpIntroHeadline
      srpIntroHeadlineEnabled
      srpIntroParagraph
      srpIntroParagraphEnabled
      metaDescription
      metaDescriptionEnabled
      metaKeywords
      metaKeywordsEnabled
      metaTitle
      metaTitleEnabled
    }
  }`,
});

/**
 * {
 *   pageNumber: Int = 1
 *   pageSize: Int = 10
 *   sortBy: $sortBy,
 *   sortDirection: $sortDirection,
 *   slugs: ['london'],,
 *   countrySlugs: ['ta'],,
 *  }
 * @param variables
 */

export const cities = variables => ({
  operationName: 'CMS_CitiesView',
  variables,
  query: `
    query CMS_CitiesView(
      $pageNumber: Int,
      $pageSize: Int,
      $countrySlugs: [String!],
      $slugs: [String],
      $sortBy:  PropertySortBy,
      $sortDirection: SortDirection,
    ) {
      cities(
      pageNumber: $pageNumber,
      pageSize: $pageSize,
      countrySlugs: $countrySlugs,
      slugs: $slugs,
      sortBy: $sortBy,
      sortDirection: $sortDirection,
      publishedStatus: ALL
    ) {
      pageInfo {
        numPages
      }
      totalCount
      edges {
        node {
          slug
          id
          name
          originalName
          published
          properties
          publishedProperties
          country {
            id
            name
            slug
            originalName
          }
          latitude
          longitude
          headline
          summary
          rank
          heroImage {
            id
            filename
            extension
            imageHash
            source
          }
          smallHeroImage {
            id
            filename
            extension
            imageHash
            source
          }
          seoTemplate {
            metaDescription
            metaKeywords
            metaTitle
            srpIntroHeadline
            srpIntroParagraph
          }
          srpIntroHeadline
          srpIntroHeadlineEnabled
          srpIntroParagraph
          srpIntroParagraphEnabled
          metaDescription
          metaDescriptionEnabled
          metaKeywords
          metaKeywordsEnabled
          metaTitle
          metaTitleEnabled
        }
      }
    }
  }`,
});

/**
 * {
 *   pageNumber: Int = 1
 *   pageSize: Int = 10
 *   publishedStatus: NodePublishedFilter = All
 *   query: String
 *  }
 * @param variables
 */

export const universities = variables => ({
  operationName: 'CMS_UniversitiesView',
  variables,
  query: `
    query CMS_UniversitiesView(
      $pageNumber: Int,
      $pageSize: Int,
      $citySlugs: [String!],
      $slugs: [String!],
      $sortBy:  PropertySortBy,
      $sortDirection: SortDirection,
    ) {
      universities(
      pageNumber: $pageNumber,
      pageSize: $pageSize,
      citySlugs: $citySlugs,
      slugs: $slugs,
      sortBy: $sortBy,
      sortDirection: $sortDirection,
      publishedStatus: ALL
    ) {
      pageInfo {
        numPages
      }
      totalCount
      edges {
        node {
          slug
          id
          name
          originalName
          published
          commonNames
          commonNamesCount
          city {
            id
            name
            slug
            originalName
          }
          headline
          heroImage {
            id
            filename
            extension
            imageHash
            source
          }
          metaDescription
          metaDescriptionEnabled
          metaKeywords
          metaKeywordsEnabled
          metaTitle
          metaTitleEnabled
          rank
          seoTemplate {
            metaDescription
            metaKeywords
            metaTitle
            srpIntroHeadline
            srpIntroParagraph
          }
          smallHeroImage {
            id
            filename
            extension
            imageHash
            source
          }
          srpIntroHeadline
          srpIntroHeadlineEnabled
          srpIntroParagraph
          srpIntroParagraphEnabled
          summary
          address
          latitude
          longitude
          zipCode
        }
      }
    }
  }
    `,
});

/**
 * {
 *   "slug": "slug",
 *  }
 * @param variables
 */
export const university = variables => ({
  operationName: 'CMS_UniversityView',
  variables,
  query: `
    query CMS_UniversityView(
      $slug: String,
    ) {
      university(
      slug: $slug,
    ) {
      id
      name
      country {
        name
        slug
      }
      city {
        name
        slug
      }
      slug
      published
      latitude
      longitude
      headline
      summary
      rank
      zipCode
      address
      commonNames
      heroImage {
        id
        filename
        extension
        imageHash
        source
      }
      smallHeroImage {
        id
        filename
        extension
        imageHash
        source
      }
      seoTemplate {
        metaDescription
        metaKeywords
        metaTitle
        srpIntroHeadline
        srpIntroParagraph
      }
      srpIntroHeadline
      srpIntroHeadlineEnabled
      srpIntroParagraph
      srpIntroParagraphEnabled
      metaDescription
      metaDescriptionEnabled
      metaKeywords
      metaKeywordsEnabled
      metaTitle
      metaTitleEnabled
      address
    }
  }`,
});

/**
 * {
 *  slug: 'london',
 *  name: 'London',
 *  latitude: 1.1237623,
 *  longitude: 2.27336,
 *  countryId: Int,
 *  published : true,
 * }
 *
 * @param variables
 */
export const createCity = variables => ({
  operationName: 'CMS_CreateCity',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreateCity($input: createCityInput!) {
      createCity(input: $input) {
        city {
          id
          name
          slug
          latitude
          longitude
          published
        }
      }
    }`,
});

/**
 * {
 *  id: 126335,
 *  published: true
 * }
 *
 * @param variables
 */
export const updateCity = variables => ({
  operationName: 'CMS_UpdateCity',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateCity($input: updateCityInput!) {
      updateCity(input: $input) {
        city {
          id
          name
          areas(pageNumber: 1,pageSize: 10){
            totalCount
          }
          universities(pageNumber: 1,pageSize: 10){
            totalCount
          }
          properties
          country {
            name
            slug
          }
          slug
          published
          latitude
          longitude
          headline
          summary
          rank
          heroImage {
            id
            filename
            extension
            imageHash
            source
          }
          smallHeroImage {
            id
            filename
            extension
            imageHash
            source
          }
          seoTemplate {
            metaDescription
            metaKeywords
            metaTitle
            srpIntroHeadline
            srpIntroParagraph
          }
          srpIntroHeadline
          srpIntroHeadlineEnabled
          srpIntroParagraph
          srpIntroParagraphEnabled
          metaDescription
          metaDescriptionEnabled
          metaKeywords
          metaKeywordsEnabled
          metaTitle
          metaTitleEnabled
        }
      }
    }`,
});

export const createUniversity = variables => ({
  operationName: 'CMS_CreateUniversity',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreateUniversity($input: createUniversityInput!) {
      createUniversity(input: $input) {
        university {
          published
          address
          latitude
          longitude
          name
          slug
          zipCode
        }
      }
    }`,
});

export const updateUniversity = variables => ({
  operationName: 'CMS_UpdateUniversity',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateUniversity($input: updateUniversityInput!) {
      updateUniversity(input: $input) {
        university {
          id
          name
          country {
            name
            slug
          }
          city {
            name
            slug
          }
          slug
          published
          latitude
          longitude
          headline
          summary
          rank
          zipCode
          address
          commonNames
          heroImage {
            id
            filename
            extension
            imageHash
            source
          }
          smallHeroImage {
            id
            filename
            extension
            imageHash
            source
          }
          seoTemplate {
            metaDescription
            metaKeywords
            metaTitle
            srpIntroHeadline
            srpIntroParagraph
          }
          srpIntroHeadline
          srpIntroHeadlineEnabled
          srpIntroParagraph
          srpIntroParagraphEnabled
          metaDescription
          metaDescriptionEnabled
          metaKeywords
          metaKeywordsEnabled
          metaTitle
          metaTitleEnabled
          address
        }
      }
    }`,
});

export const createArea = variables => ({
  operationName: 'CMS_CreateArea',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreateArea($input: CreateAreaInput!) {
      createArea(input: $input) {
        area {
          id
          name
          slug
        }
      }
    }`,
});

export const updateArea = variables => ({
  operationName: 'CMS_UpdateArea',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateArea($input: UpdateAreaInput!) {
      updateArea(input: $input) {
        area {
          id
          name
          city {
            name
            slug
          }
          slug
          published
          headline
          summary
          properties
          rank
          heroImage {
            id
            filename
            extension
            imageHash
            source
          }
          smallHeroImage {
            id
            filename
            extension
            imageHash
            source
          }
          seoTemplate {
            metaDescription
            metaKeywords
            metaTitle
            srpIntroHeadline
            srpIntroParagraph
          }
          srpIntroHeadline
          srpIntroHeadlineEnabled
          srpIntroParagraph
          srpIntroParagraphEnabled
          metaDescription
          metaDescriptionEnabled
          metaKeywords
          metaKeywordsEnabled
          metaTitle
          metaTitleEnabled
        }
      }
    }`,
});

/**
 * {
 *   "slug": "slug",
 *  }
 * @param variables
 */
export const area = variables => ({
  operationName: 'CMS_AreaView',
  variables,
  query: `
    query CMS_AreaView(
      $slug: String,
    ) {
      area(
      slug: $slug,
    ) {
      id
      name
      city {
        name
        slug
      }
      slug
      published
      headline
      summary
      properties
      rank
      heroImage {
        id
        filename
        extension
        imageHash
        source
      }
      smallHeroImage {
        id
        filename
        extension
        imageHash
        source
      }
      seoTemplate {
        metaDescription
        metaKeywords
        metaTitle
        srpIntroHeadline
        srpIntroParagraph
      }
      srpIntroHeadline
      srpIntroHeadlineEnabled
      srpIntroParagraph
      srpIntroParagraphEnabled
      metaDescription
      metaDescriptionEnabled
      metaKeywords
      metaKeywordsEnabled
      metaTitle
      metaTitleEnabled
    }
  }`,
});

export const updateLocationImage = variables => ({
  operationName: 'CMS_UpdateLocationImage',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateLocationImage($input: updateLocationImageInput!) {
      updateLocationImage(input: $input) {
        image {
          id
        }
      }
    }`,
});

export const createLocationImage = variables => ({
  operationName: 'CMS_CreateLocationImage',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreateLocationImage($input: LocationImageInput!) {
      createLocationImage(input: $input) {
        image {
          id
        }
      }
    }`,
});

export const deletedLocationImage = variables => ({
  operationName: 'CMS_DeleteLocationImage',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_DeleteLocationImage($input: deleteLocationImageInput!) {
      deleteLocationImage(input: $input) {
        image {
          id
        }
      }
    }`,
});

export const getUploadVideoToken = () => ({
  operationName: 'CMS_getUploadVideoToken',
  query: `
  mutation CMS_getUploadVideoToken {
    getUploadVideoToken {
      sessionToken
      accessKeyId
      secretAccessKey
      region
      bucket
      expiration
    }
  }`,
});

export const checkVideoUploaded = variables => ({
  operationName: 'CMS_videoIsUploaded',
  variables: {
    input: variables,
  },
  query: `
  mutation CMS_videoIsUploaded($input: videoIsUploadedInput!) {
    videoIsUploaded(input: $input)
  }`,
});

export const createVideo = variables => ({
  operationName: 'CMS_createVideo',
  variables: {
    input: variables,
  },
  query: `
  mutation CMS_createVideo(
    $input: createVideoInput!
  ) {
    createVideo(
      input: $input
    ) {
      video {
        active
        alternateText
        extension
        id
        locales
        path
        position
        size
        thumbnailCount
        transcodedStatus
        transcodeJobId
        transcodeJobStatus
        unitTypeId
        videoHash
        fileName
        category
        links {
          hls
          hqMp4
          lqMp4
          thumbnail
        }
      }
    }
  }`,
});

export const createProperty = variables => ({
  operationName: 'CMS_createProperty',
  variables: {
    input: variables,
  },
  query: `
  mutation CMS_createProperty(
    $input: CreatePropertyInput!
  ) {
    createProperty(
      input: $input
    ) {
      property {
        id
        slug
        name
      }
    }
  }`,
});

export const createCommission = variables => ({
  operationName: 'CMS_CreateCommission',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreateCommission($input: CreateCommissionTierInput!) {
      createCommissionTier(input: $input) {
        commissionTier {
          id
          category
          name
          value
          status
          bonus
          bookingCountFrom
          bookingCountTo
          capType
          capValue
          checkInDateFrom
          checkInDateTo
          convertedCalculationValue
          description
          effectiveFrom
          effectiveTo
          fullyCalculatable
          percentageForReport
          retrospectiveCommission
          tenancyLengthFrom
          tenancyLengthTo
          tenancyUnit
          type
        }
      }
    }`,
});

export const deleteCommission = variables => ({
  operationName: 'CMS_DeleteCommission',
  variables: {
    input: variables,
  },
  query: `
  mutation CMS_DeleteCommission($input: DeleteCommissionTierInput!) {
    deleteCommissionTier(input: $input) {
      deletedCommissionTierId
    }
  }`,
});

export const updateCommission = variables => ({
  operationName: 'CMS_UpdateCommission',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateCommission($input: UpdateCommissionTierInput!) {
      updateCommissionTier(input: $input) {
        commissionTier {
          id
          category
          name
          value
          status
          bonus
          bookingCountFrom
          bookingCountTo
          capType
          capValue
          checkInDateFrom
          checkInDateTo
          convertedCalculationValue
          description
          effectiveFrom
          effectiveTo
          fullyCalculatable
          percentageForReport
          retrospectiveCommission
          tenancyLengthFrom
          tenancyLengthTo
          tenancyUnit
          type
        }
      }
    }`,
});

export const updatePropertyContractNote = variables => ({
  operationName: 'CMS_UpdatePropertyContractNote',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdatePropertyContractNote($input: UpdatePropertyContractNoteInput!) {
      updatePropertyContractNote(input: $input) {
        propertyContractNote {
          createdAt
          description
          id
          newContractStage
          oldContractStage
          title
          updatedAt
          updatedBy
        }
      }
    }`,
});

export const deletePropertyContractNote = variables => ({
  operationName: 'CMS_DeletePropertyContractNote',
  variables: {
    input: variables,
  },
  query: `
  mutation CMS_DeletePropertyContractNote($input: DeletePropertyContractNoteInput!) {
    deletePropertyContractNote(input: $input) {
      propertyContractNote {
        createdAt
        description
        id
        newContractStage
        oldContractStage
        propertyId
        title
        updatedAt
        updatedBy
      }
    }
  }`,
});

export const deleteContract = variables => ({
  operationName: 'CMS_DeleteContract',
  variables: {
    input: variables,
  },
  query: `
  mutation CMS_DeleteContract($input: DeleteContractInput!) {
    deleteContract(input: $input) {
      contract {
        id
      }
    }
  }`,
});

export const createDeposit = variables => ({
  operationName: 'CMS_CreateDeposit',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreateDeposit($input: CreatePaymentDepositRuleInput!) {
      createPaymentDepositRule(input: $input) {
        paymentDepositRule {
          id
          name
          value
        }
      }
    }`,
});

export const updateDeposit = variables => ({
  operationName: 'CMS_UpdateDeposit',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateDeposit($input: UpdatePaymentDepositRuleInput!) {
      updatePaymentDepositRule(input: $input) {
        paymentDepositRule {
          id
          name
          value
        }
      }
    }`,
});

export const deletedDeposit = variables => ({
  operationName: 'CMS_DeletedDeposit',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_DeletedDeposit($input: DeletePaymentDepositRuleInput!) {
      deletePaymentDepositRule(input: $input) {
        deletedPaymentDepositRuleId
      }
    }`,
});

export const updatePropertyEnablePayment = variables => ({
  operationName: 'CMS_UpdateProperty',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateProperty($input: UpdatePropertyInput!) {
      updateProperty (input:$input) {
        property {
          id
          paymentsEnabled
        }
      }
    }
  `,
});

export const enableBookNow = variables => ({
  operationName: 'CMS_EnableBookNow',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_EnableBookNow($input: EnableBookNowInput!) {
      enableBookNow (input:$input) {
        paymentProperty {
          id
          paymentsEnabled
        }
      }
    }
  `,
});

export const searchLandlordList = variables => ({
  operationName: 'search',
  variables,
  query: `query search($query:String, $pageNumber: Int, $pageSize: Int  ) {
  search(query: $query, pageSize: $pageSize, pageNumber: $pageNumber, publishedStatus: PUBLISHED) {
    totalCount
    edges {
      node {
        ... on Landlord {
          type: __typename
          slug
          name
          id
        }
      }
    }
  }
}`,
});

export const landlordProperties = variables => ({
  operationName: 'CMS_PropertiesView',
  variables,
  query: `
    query CMS_PropertiesView(
      $slug: String,
    ) {
      properties(
      landlordSlug: $slug,
      pageSize: 9999
    ) {
        edges {
          node {
            name
            slug
            id
          }
        }
    }
  }`,
});

export const createContract = variables => ({
  operationName: 'CMS_CreateContract',
  variables: {
    input: variables,
  },
  query: `
  mutation CMS_CreateContract($input: CreateContractInput!) {
    createContract(input: $input) {
      contract {
        effectiveFrom
        effectiveTo
        landlord {
          name
          id
          slug
        }
        signedDate
        status
      }
    }
  }`,
});

export const updateContract = variables => ({
  operationName: 'CMS_UpdateContract',
  variables: {
    input: variables,
  },
  query: `
  mutation CMS_UpdateContract($input: UpdateContractInput!) {
    updateContract(input: $input) {
      contract {
        effectiveFrom
        effectiveTo
        landlord {
          name
          id
          slug
        }
        signedDate
        status
      }
    }
  }`,
});

export const getContractList = variables => ({
  operationName: 'CMS_ContractView',
  variables,
  query: `
    query CMS_ContractView(
      $pageNumber: PositiveInteger,
      $pageSize: PositiveInteger,
      $signedDateStart: Date,
      $signedDateEnd: Date,
      $landlordSlugs: [String!],
      $effectiveStart: Date,
      $effectiveEnd: Date,
      $statuses: [ContractStatus!]
      $sortBy: ContractSortBy
      $sortDirection: SortDirection
    ) {
      contracts(
        pageSize: $pageSize,
        pageNumber: $pageNumber,
        signedDateStart: $signedDateStart,
        signedDateEnd: $signedDateEnd,
        landlordSlugs: $landlordSlugs,
        effectiveStart: $effectiveStart,
        effectiveEnd: $effectiveEnd,
        statuses: $statuses
        sortBy: $sortBy
        sortDirection: $sortDirection
    ) {
      pageInfo {
        numPages
      }
      totalCount
      edges {
        node {
          id
          createdAt
          effectiveFrom
          effectiveTo
          landlord {
            name
            id
            slug
          }
          status
          updatedAt
          signedDate
          files {
            id
            name
            source
            updatedAt
            contentType
            contractId
            createdAt
          }
          properties {
            id
            name
          }
        }
      }
    }
  }`,
});

export const bulkDuallySigned = variables => ({
  operationName: 'CMS_DuallySigned',
  variables,
  query: `
  mutation CMS_DuallySigned($propertyIds: [ID!]) {
    bulkUpdatePropertyStage(propertyIds: $propertyIds) {
      description
      status
    }
  }`,
});

export const getLandlordUser = variables => ({
  operationName: 'CMS_LandlordContactUser',
  variables,
  query: `
  query CMS_LandlordContactUser($userUuid: NonEmptyString!) {
    landlordContact(userUuid: $userUuid) {
      firstName
      lastName
      email
      id
      landlordId
      liveChatEnabled
      properties (pageNumber:1,  pageSize: 1) {
        totalCount
      }
      company {
        id
        reconciliationOption
        pendingAt
        verifiedAt
        accountManager
      }
    }
  }`,
});

export const createAccount = variables => ({
  operationName: 'CMS_createAccount',
  variables: {
    input: variables,
  },
  query: `
  mutation CMS_createAccount(
    $input: createCmsUserInput!
  ) {
    createCmsUser(
      input: $input
    ) {
      cmsUser {
        id
      }
    }
  }`,
});

export const updateAccount = variables => ({
  operationName: 'CMS_updateAccount',
  variables: {
    input: variables,
  },
  query: `
  mutation CMS_updateAccount(
    $input: UpdateLandlordContactInput!
  ) {
    updateLandlordContact(
      input: $input
    ) {
      landlordContact {
        id
      }
    }
  }`,
});

export const cmsUsers = variables => ({
  operationName: 'CMS_CMSUsersView',
  variables,
  query: `
    query CMS_CMSUsersView(
      $pageNumber: Int,
      $pageSize: Int,
      $sortBy:  CmsUsersSortBy,
      $landlordSlugs: [NonEmptyString],
      $sortDirection: SortDirection,
      $email: NonEmptyString,
    ) {
      cmsUsers(
        pageSize: $pageSize,
        pageNumber: $pageNumber,
        landlordSlugs: $landlordSlugs,
        sortBy: $sortBy,
        sortDirection: $sortDirection,
        email: $email,
    ) {
      totalCount
      edges {
        node {
          enabled
          email
          firstName
          id
          lastName
          updatedAt
          userRoles {
            name
            slug
          }
          userUuid
          landlord {
            id
            name
            slug
          }
        }
      }
    }
  }`,
});

export const checkUserExist = variables => ({
  operationName: 'CMS_CheckUserExist',
  variables,
  query: `
    query CMS_CheckUserExist(
      $type:  CreateCmsUserType!,
      $value: String!,
    ) {
      checkCmsUserExist(
        type: $type,
        value: $value,
    ) {
      exist
    }
  }`,
});

/**
 *
 * @param {object} variables
 *  {
 *    email: "",
 *    password: "",
 *  }
 */
export const login = variables => ({
  operationName: 'CMS_Login',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_Login($input: CmsUserLoginInput) {
      cmsUserLogin(input: $input) {
        authToken
      }
    }
  `,
});

export const getPendingApprovalDetails = variables => ({
  operationName: 'CMS_DraftView',
  variables,
  query: `
    query CMS_DraftView(
      $id: ID!,
    ) {
      draft(
        id: $id,
    ) {
      approvedBy
      changes
      createdAt
      createdBy
      expiredBy
      id
      property {
        id
        name
        city {
          slug
          name
          country {
            slug
            name
          }
        }
      }
      propertyId
      status
      updatedAt
    }
  }`,
});

export const pendingApprovePropertyDraft = variables => ({
  operationName: 'CMS_pendingApprovePropertyDraft',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_pendingApprovePropertyDraft($input: CreatePropertyDraftInput!) {
      pendingApprovePropertyDraft(input: $input) {
        propertyDraft {
          approvedBy
          changes
          createdAt
          createdBy
          expiredBy
          id
          status
          updatedAt
        }
      }
    }`,
});

export const cancelPropertyDraft = variables => ({
  operationName: 'CMS_CancelPropertyDraft',
  variables,
  query: `
    mutation CMS_CancelPropertyDraft($id: ID!) {
      cancelPropertyDraft(id: $id) {
        propertyDraft {
          id
          status
          updatedAt
          property {
            id
            name
            slug
            city {
              slug
              name
              country {
                slug
                name
              }
            }
          }
        }
      }
    }`,
});

export const savePropertyDraft = variables => ({
  operationName: 'CMS_SavePropertyDraft',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_SavePropertyDraft($input: CreatePropertyDraftInput!) {
      savePropertyDraft(input: $input) {
        propertyDraft {
          approvedBy
          changes
          createdAt
          createdBy
          expiredBy
          id
          status
          updatedAt
          version
        }
      }
    }
  `,
});

export const approvalPropertyDraft = variables => ({
  operationName: 'CMS_ApprovalPropertyDraft',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_ApprovalPropertyDraft(
      $input: approvalPropertyDraftInput!
    ) {
      approvalPropertyDraft(
        input: $input,
      ) {
        propertyDraft {
          approvedBy
          changes
          createdAt
          createdBy
          expiredBy
          id
          status
          updatedAt
          version
        }
      }
    }
  `,
});

export const rejectPropertyDraft = variables => ({
  operationName: 'CMS_RejectPropertyDraft',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_RejectPropertyDraft(
      $input: rejectPropertyDraftInput!
    ) {
      rejectPropertyDraft(
        input: $input,
      ) {
        propertyDraft {
          approvedBy
          changes
          createdAt
          createdBy
          expiredBy
          id
          status
          updatedAt
          version
        }
      }
    }
  `,
});

export const getUserAuth = () => ({
  operationName: 'CMS_GetUserAuth',
  query: `
  query CMS_GetUserAuth {
    identity {
      id
      identity {
        frontendScopes {
          role
          scopes {
            object
            permission
          }
        }
      }
    }
  }`,
});

export const getPropertyPreview = variables => ({
  operationName: 'CMS_PropertyPreview',
  variables,
  query: `
  query CMS_PropertyPreview(
    $slug: String,
  ) {
    property(
      slug: $slug,
    ) {
      id
      name
      slug
      currency
      acceptsDepositPayment
      waitinglistEnabled
      allVideos(statuses: [EXTERNAL_NEW, PENDING, APPROVED]) {
        unitTypeId
        category
        position
        locales
        id
        links {
          hls
          hqMp4
          lqMp4
          thumbnail
        }
      }
      price{
        isFrom
        minPrice
        discountedMinPrice
      }
      city{
        id
        slug
        name
        originalName
        country{
          name
          slug
        }
      }
      allLinks(statuses: [EXTERNAL_NEW, PENDING, APPROVED]) {
        area
        propertyId
        link
        type
        displayRegion
        enabled
        id
        label
      }
      status
      billingCycle
      bookingType
      externalId
      address
      addressLine2
      zipCode
      specialOffers {
        edges {
          node {
            id
            createdAt
            title      
            description
            termsAndConditions
          }
        }
      }
      minPrice
      facilities(range: CHECKED){
        tags
        label
        slug
        rank
        group
        checked
        name
      }
      allImages(statuses: [EXTERNAL_NEW, PENDING, APPROVED]) {
        edges{
          node{
            category
            hero
            source
            alternateText
            unitTypeId
            position
          }
        }
      }
      description
      totalBeds
      cancellationChecked
      cancellationProcess
      cancellationPeriodValue
      cancellationPeriodType
      url
      landlordPhotograpyUrl
      roomMatrixUrl
      rank
      rankWeight
      latitude
      longitude
      state
      contentContactName
      reviews(pageSize: 10) {
        edges {
          node {
            headline
            content
            createdAt
            university
            location
            nickname
            rating
          }
        }
      }
      reviewsSummary {
        count
        averageRating
        averageRatingFacility
        averageRatingLocation
        averageRatingTransport
        averageRatingSafety
        averageRatingStaff
        averageRatingValue
      }
      wishlistCount
      acceptsDepositPayment
      bookNumber
      headline
      area {
        id
        slug
        name
        originalName         
      }
      unitTypes{
        edges {
          node {
            id
            name
            category
            floors
            roomSize
            roomType
            bathroomType
            viewType
            kitchenArrangement
            bedCount
            bedroomCountMin
            bedroomCountMax
            specialOffers {
              edges {
                node {
                  title
                  internalTitle
                  termsAndConditions
                  description
                }
              }
            }
            lastFurnished
            facilities(version: "v2") {
              group
              checked
              label
              slug
            }
            genderMix
            smokingPreference
            dietaryPreference
            unitTypeBedSizes {
              type
              length
              width
              bedCount
            }
            listings {
              id
              type
              moveInType
              moveOutType
              moveIn
              moveOut
              tenancyLengthType
              tenancyLengthValue
              availability
              state
              priceMin
              priceMax
              discountValue
              discountType
              fixed
              availableThoughMoveInDatePassed
            }
            price {
              isFrom
              minPrice
              discountedMinPrice
            }
            allImages(statuses: [EXTERNAL_NEW, PENDING, APPROVED]) {
              edges {
                node {
                  id
                  propertyId
                  unitTypeId
                  discriminator
                  category
                  height
                  width
                  size
                  lastModifiedHash
                  extension
                  contentType
                  hero
                  thumbnail
                  path
                  position
                  source
                  filename
                  imageHash
                  alternateText
                }
              }
            }
            allLinks(statuses: [EXTERNAL_NEW, PENDING, APPROVED]) {
              displayRegion
              enabled
              id
              link
              type
              unitTypeId
            }
            allVideos(statuses: [EXTERNAL_NEW, PENDING, APPROVED]) {
              links {
                hls
                hqMp4
                lqMp4
                thumbnail
              }
              locales
              position
            }
          }
        }
      }
    }
  }
  `,
});

export const updatePropertyDetails = variables => ({
  operationName: 'CMS_UpdatePropertyDetails',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdatePropertyDetails($input: UpdatePropertyDetailsInput!) {
      updatePropertyDetails(input: $input) {
        property {
          id
          slug
          drafts(
            sortBy: UPDATED_AT,
            pageNumber: 1,
            pageSize: 9999,
            statuses: [PENDING, REJECTED, EXPIRED],
          ) {
            edges {
              node {
                id
                status
                updatedAt
                changes
                category
                createdUser {
                  firstName
                  lastName
                  email
                }
                comments {
                  comment
                  id
                  section
                }
                image {
                  id
                  discriminator
                  category
                  size
                  extension
                  contentType
                  hero
                  path
                  position
                  source
                  filename
                  imageHash
                  status
                  unitTypeId
                }
                video {
                  id
                  path
                  transcodedStatus
                  links {
                    hls
                    hqMp4
                    lqMp4
                    thumbnail
                  }
                  locales
                  category
                  position
                  size
                  unitTypeId
                  videoHash
                  fileName
                  extension
                  transcodeJobId
                  transcodeJobStatus
                  status
                }
                propertyLink {
                  area
                  displayRegion
                  id
                  link
                  type
                  propertyId
                  status
                }
                unitTypeLink {
                  displayRegion
                  id
                  link
                  type
                  status
                  unitTypeId
                }
              }
            }
          }
        }
      }
    }
  `,
});

export const updatePropertyDueHours = variables => ({
  operationName: 'CMS_UpdatePropertyDueHours',
  variables: {
    input: variables,
  },
  query: `mutation CMS_UpdatePropertyDueHours($input:UpdatePropertyDueHoursInput!) {
    updatePropertyDueHours(input:$input){
      property {
          id
          slug
          drafts(
            sortBy: UPDATED_AT,
            pageNumber: 1,
            pageSize: 9999,
            statuses: [PENDING, REJECTED, EXPIRED],
          ) {
            edges {
              node {
                id
                status
                updatedAt
                changes
                category
                createdUser {
                  firstName
                  lastName
                  email
                }
                comments {
                  comment
                  id
                  section
                }
                image {
                  id
                  discriminator
                  category
                  size
                  extension
                  contentType
                  hero
                  path
                  position
                  source
                  filename
                  imageHash
                  status
                  unitTypeId
                }
                video {
                  id
                  path
                  transcodedStatus
                  links {
                    hls
                    hqMp4
                    lqMp4
                    thumbnail
                  }
                  locales
                  category
                  position
                  size
                  unitTypeId
                  videoHash
                  fileName
                  extension
                  transcodeJobId
                  transcodeJobStatus
                  status
                }
                propertyLink {
                  area
                  displayRegion
                  id
                  link
                  type
                  propertyId
                  status
                }
                unitTypeLink {
                  displayRegion
                  id
                  link
                  type
                  status
                  unitTypeId
                }
              }
            }
          }
        }
    }
  }
    `,
});

export const bindPropertyFacilities = variables => ({
  operationName: 'CMS_BindPropertyFacilities',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_BindPropertyFacilities($input: BindPropertyFacilitiesInput!) {
      bindPropertyFacilities(
        input: $input,
      ) {
        result
      }
    }`,
});

export const bindPropertyUniversities = variables => ({
  operationName: 'CMS_BindPropertyUniversities',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_BindPropertyUniversities($input: BindPropertyUniversitiesInput!) {
      bindPropertyUniversities(
        input: $input,
      ) {
        result
      }
    }`,
});

export const bindPropertyDocumentations = variables => ({
  operationName: 'CMS_BindPropertyDocumentations',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_BindPropertyDocumentations($input: BindPropertyDocumentationsInput!) {
      bindPropertyDocumentations(
        input: $input,
      ) {
        result
      }
    }`,
});

export const updatePropertyAddress = variables => ({
  operationName: 'CMS_UpdatePropertyAddress',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdatePropertyAddress($input: UpdatePropertyAddressInput!) {
      updatePropertyAddress(
        input: $input,
      ) {
        property{
          id
          address
          latitude
          longitude
        }
      }
    }`,
});

export const updatePropertyTenancyAgreement = variables => ({
  operationName: 'CMS_UpdatePropertyTenancyAgreement',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdatePropertyTenancyAgreement($input: UpdatePropertyTenancyAgreementInput!) {
      updatePropertyTenancyAgreement(
        input: $input,
      ) {
        tenancyAgreement{
          id
        }
      }
    }`,
});

export const createPropertyTenancyAgreement = variables => ({
  operationName: 'CMS_CreatePropertyTenancyAgreement',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreatePropertyTenancyAgreement($input: CreatePropertyTenancyAgreementInput!) {
      createPropertyTenancyAgreement(
        input: $input,
      ) {
        tenancyAgreement{
          id
        }
      }
    }`,
});

export const deleteRoom = variables => ({
  operationName: 'CMS_DeleteRoom',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_DeleteRoom($input: DeleteRoomInput!) {
      deleteRoom(
        input: $input,
      ) {
        unitType {
          id
        }
     }
    }`,
});

export const createRoom = variables => ({
  operationName: 'CMS_CreateRoom',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreateRoom($input: CreateRoomInput!) {
      createRoom(
        input: $input,
      ) {
        unitType {
          id
          name
          category
          roomSize
          roomType
          viewType
          bedCount
          kitchenArrangement
          maxOccupancy
          dualOccupancy
          bathroomType
          floors
          bedSizeType
          inventoryType
          unitTypeBedSizes{
            id
            type
            length
            width
            bedCount
          }
          facilities(version: "v2"){
            slug
            label
            group
            checked
          }
          lastFurnished
          bedroomCountMin
          bedroomCountMax
          bedCount
          bathroomCount
          kitchenCount
          genderMix
          dietaryPreference
          smokingPreference
          genderMix
          smokingPreference
          dietaryPreference
          updatedAt
          allLinks {
            displayRegion
            id
            link
            type
            unitTypeId
            status
          }
          listings {
            id
            type
            priceMin
            priceMax
            tenancyLengthType
            tenancyLengthValue
            availability
            liveOn
            liveUntil
            autoPriceAllowed
            autoAvailAllowed
            discountType
            discountValue
            updatedAt
            moveIn
            moveInType
            moveOut
            moveOutType
            fixed
            availableThoughMoveInDatePassed
          }
          allVideos {
            id
            path
            transcodedStatus
            links {
              hls
              hqMp4
              lqMp4
              thumbnail
            }
            category
            locales
            position
            size
            unitTypeId
            videoHash
            fileName
            extension
            transcodeJobId
            transcodeJobStatus
            status
          }
          allImages {
            edges {
              node {
                id
                discriminator
                height
                width
                size
                extension
                contentType
                hero
                path
                position
                source
                filename
                imageHash
                status
              }
            }
          }
        }
     }
    }`,
});

export const updateRoom = variables => ({
  operationName: 'CMS_UpdateRoom',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateRoom($input: UpdateRoomInput!) {
      updateRoom(
        input: $input,
      ) {
        unitType {
          id
          name
          category
          roomSize
          roomType
          viewType
          bedCount
          kitchenArrangement
          maxOccupancy
          dualOccupancy
          bathroomType
          floors
          bedSizeType
          inventoryType
          unitTypeBedSizes{
            id
            type
            length
            width
            bedCount
          }
          facilities(version: "v2"){
            slug
            label
            group
            checked
          }
          lastFurnished
          bedroomCountMin
          bedroomCountMax
          bedCount
          bathroomCount
          kitchenCount
          genderMix
          dietaryPreference
          smokingPreference
          genderMix
          smokingPreference
          dietaryPreference
          updatedAt
          links {
            displayRegion
            enabled
            id
            link
            type
            unitTypeId
          }
          listings {
            id
            type
            priceMin
            priceMax
            tenancyLengthType
            tenancyLengthValue
            availability
            liveOn
            liveUntil
            autoPriceAllowed
            autoAvailAllowed
            discountType
            discountValue
            updatedAt
            moveIn
            moveInType
            moveOut
            moveOutType
            fixed
            availableThoughMoveInDatePassed
          }
          videos {
            id
            path
            transcodedStatus
            links {
              hls
              hqMp4
              lqMp4
              thumbnail
            }
            category
            locales
            position
            size
            unitTypeId
            videoHash
            fileName
            extension
            transcodeJobId
            transcodeJobStatus
          }
          images {
            edges {
              node {
                id
                discriminator
                height
                width
                size
                extension
                contentType
                hero
                path
                position
                source
                filename
                imageHash
              }
            }
          }
        }
     }
    }`,
});

export const deleteListing = variables => ({
  operationName: 'CMS_DeleteListing',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_DeleteListing($input: DeleteListingInput!) {
      deleteListing(
        input: $input,
      ) {
        deletedListingId
     }
    }`,
});

export const createListing = variables => ({
  operationName: 'CMS_CreateListing',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_CreateListing($input: CreateListingInput!) {
      createListing(
        input: $input,
      ) {
        listing {
          autoAvailAllowed
          autoPriceAllowed
          availability
          discountType
          discountValue
          id
          liveOn
          liveUntil
          minPrice
          moveIn
          moveInType
          moveOut
          moveOutType
          priceMax
          priceMin
          state
          tenancyLengthType
          tenancyLengthValue
          type
          fixed
          updatedAt
          inventoryCount
          availableThoughMoveInDatePassed
          turnaroundType
          turnaroundTime
        }
     }
    }`,
});

export const updateListing = variables => ({
  operationName: 'CMS_UpdateListing',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateListing($input: UpdateListingInput!) {
      updateListing(
        input: $input,
      ) {
        listing {
          autoAvailAllowed
          autoPriceAllowed
          availability
          discountType
          discountValue
          id
          liveOn
          liveUntil
          minPrice
          moveIn
          moveInType
          moveOut
          moveOutType
          priceMax
          priceMin
          state
          tenancyLengthType
          tenancyLengthValue
          type
          updatedAt
          inventoryCount
          fixed
          turnaroundType
          turnaroundTime
        }
     }
    }`,
});

export const bulkUpdateListings = variables => ({
  operationName: 'CMS_BulkUpdateListings',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_BulkUpdateListings($input: BulkUpdateListingsInput!) {
      bulkUpdateListings(
        input: $input,
      ) {
        listings {
          autoAvailAllowed
          autoPriceAllowed
          availability
          discountType
          discountValue
          id
          liveOn
          liveUntil
          minPrice
          moveIn
          moveInType
          moveOut
          moveOutType
          priceMax
          priceMin
          state
          tenancyLengthType
          tenancyLengthValue
          type
          updatedAt
          fixed
          availableThoughMoveInDatePassed
        }
     }
    }`,
});

export const updateListingAdminSetting = variables => ({
  operationName: 'CMS_UpdateListingAdminSetting',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateListingAdminSetting($input: UpdateListingAdminSettingInput!) {
      updateListingAdminSetting(
        input: $input,
      ) {
        listing {
          autoAvailAllowed
          autoPriceAllowed
          availability
          discountType
          discountValue
          id
          liveOn
          liveUntil
          minPrice
          moveIn
          moveInType
          moveOut
          moveOutType
          priceMax
          priceMin
          state
          tenancyLengthType
          tenancyLengthValue
          type
          updatedAt
          fixed
        }
     }
    }`,
});

export const updateGallery = variables => ({
  operationName: 'CMS_UpdateGallery',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_UpdateGallery($input: UpdateGalleryInput!) {
      updateGallery(
        input: $input,
      ) {
        gallery {
          allImages {
            edges {
              node {
                active
                alternateText
                category
                contentType
                discriminator
                extension
                filename
                height
                hero
                id
                imageHash
                lastModifiedHash
                path
                position
                propertyId
                size
                source
                thumbnail
                unitTypeId
                width
                status
              }
            }
          }
          allVideos {
            active
            alternateText
            category
            extension
            fileName
            id
            links {
              hls
              hqMp4
              lqMp4
              thumbnail
            }
            locales
            path
            position
            size
            thumbnailCount
            transcodedStatus
            transcodeJobId
            transcodeJobStatus
            unitTypeId
            videoHash
            status
          }
          allLinks {
            area
            displayRegion
            id
            link
            propertyId
            type
            status
          }
          propertyId
          unitTypeGallerys {
            allImages {
              edges {
                node {
                  active
                  alternateText
                  category
                  contentType
                  discriminator
                  extension
                  filename
                  height
                  hero
                  id
                  imageHash
                  lastModifiedHash
                  path
                  position
                  propertyId
                  size
                  source
                  thumbnail
                  unitTypeId
                  width
                  status
                }
              }
            }
            allVideos {
              active
              alternateText
              category
              extension
              fileName
              id
              links {
                hls
                hqMp4
                lqMp4
                thumbnail
              }
              locales
              path
              position
              size
              thumbnailCount
              transcodedStatus
              transcodeJobId
              transcodeJobStatus
              unitTypeId
              videoHash
              status
            }
            allLinks {
              displayRegion
              id
              link
              type
              status
              unitTypeId
            }
            unitTypeId
          }
        }
      }
    }`,
});

export const pendingApprovalList = variables => ({
  operationName: 'CMS_PendingApprovalList',
  variables,
  query: `
    query CMS_PendingApprovalList {
      pendingApproveList(statuses: [PENDING, REJECTED, EXPIRED]) {
        drafts {
          city {
            name
            country {
              name
            }
          }
          draftsCategory
          draftsStatus
          propertyId
          propertyName
          propertyPublished
          propertySlug
          updatedAt
        }
      }
    }`,
});

/**
 * {
 *  id: "eyJ0eXBlIjoiUHJvcGVydHkiLCJpZCI6NTg0fQ",
 * }
 *
 * @param variables
 */
export const requestPublish = variables => ({
  operationName: 'CMS_RequestPublish',
  variables: {
    input: variables,
  },
  query: `
    mutation CMS_RequestPublish($input: RequestPublishInput!) {
      requestPublish(
        input: $input,
      ) {
        description
        error
        status
        statusCode
      }
    }`,
});

export const getPropertyDrafts = variables => ({
  operationName: 'CMS_GetPropertyDrafts',
  variables: {
    propertyId: variables,
  },
  query: `
    query CMS_GetPropertyDrafts(
      $propertyId: ID,
    ) {
      drafts(
        sortBy: UPDATED_AT,
        pageNumber: 1,
        pageSize: 9999,
        propertyId: $propertyId,
        statuses: [PENDING, REJECTED, EXPIRED],
      ) {
        edges {
          node {
            id
            status
            updatedAt
            changes
            category
            createdUser {
              firstName
              lastName
              email
            }
            comments {
              comment
              id
              section
            }
            image {
              id
              discriminator
              category
              size
              extension
              contentType
              hero
              path
              position
              source
              filename
              imageHash
              status
              unitTypeId
            }
            video {
              id
              path
              transcodedStatus
              links {
                hls
                hqMp4
                lqMp4
                thumbnail
              }
              locales
              category
              position
              size
              unitTypeId
              videoHash
              fileName
              extension
              transcodeJobId
              transcodeJobStatus
              status
            }
            propertyLink {
              area
              displayRegion
              id
              link
              type
              propertyId
              status
            }
            unitTypeLink {
              displayRegion
              id
              link
              type
              status
              unitTypeId
            }
          }
        }
      }
    }`,
});

export const queryUnitTypeFacilities = () => ({
  operationName: 'CMS_queryUnitTypeFacilities',
  variables: {},
  query: `
    query CMS_queryUnitTypeFacilities {
      facilities(type: UNIT_TYPE, version: "v2") {
        group
        label
        name
        rank
        slug
        tags
      }
    }
  `,
});

export const createOfflinePaymentMethod = variables => ({
  operationName: 'DASHBOARD_CreateOfflinePaymentMethod',
  variables,
  query: `
    mutation DASHBOARD_CreateOfflinePaymentMethod($input: CreateOfflinePaymentMethodInput!) {
      createOfflinePaymentMethod(
        input: $input,
      ) {
        offlinePaymentMethod {
          id
        }
      }
  }`,
});

export const updateOfflinePaymentMethod = variables => ({
  operationName: 'DASHBOARD_UpdateOfflinePaymentMethod',
  variables,
  query: `
    mutation DASHBOARD_UpdateOfflinePaymentMethod($input: UpdateOfflinePaymentMethodInput!) {
      updateOfflinePaymentMethod(
        input: $input,
      ) {
        offlinePaymentMethod {
          id
        }
      }
  }`,
});
